module.exports = __webpack_public_path__ + "img/honor-act.32ce556b.png";